import Type2 from "./footerType2";

export default Type2;
